import { ReactNode } from 'react';

import styles from './Text.module.css';

type Variant = 'Body' | 'Heading';

type Size = 'Small' | 'Midsize' | 'Large' | 'XLarge';

type Type = 'Light' | 'Regular' | 'Medium' | 'Bold';

type TextProps = {
  variant: Variant;
  size: Size;
  type: Type;
  className?: string;
  children?: ReactNode;
  testId?: string;
  ariaLabel?: string;
};

function Text({ variant, size, type, className = '', children, testId, ariaLabel = '' }: TextProps): ReactNode {
  return (
    <span
      className={` ${styles.Text} ${styles[variant + size]} ${styles[type]} ${className}`}
      data-testid={testId}
      aria-label={ariaLabel}
    >
      {children}
    </span>
  );
}

export default Text;
